import React, { useContext, useEffect, useState } from "react";
import { GoalFormNavigationButton } from "../../goal_templates/common/components/generalUtilities";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";
import { MonitorProgramDropdown } from "../common/components/monitorProgramDropdown";

export const GoalTemplateReloadContainer = ({ closeModal }) => {
  const { DBObject, t, uuid, setMonitorProgramId } = useContext(TMDataContext);
  const [selectedProgram, setSelectedProgram] = useState(null);

  const buildTable = () => {
    return selectedProgram.goalTemplateList.map((template) => {
      return (
        <tr key={uuid()}>
          <td className="patient-goal-table-data-cell">{template.name}</td>
          <td className="patient-goal-table-data-cell">{template.type}</td>
          <td className="patient-goal-table-data-cell">{template.frequency}</td>
          <td className="patient-goal-table-data-cell">
            {template.occurrence}
          </td>
          <td className="patient-goal-table-data-cell">
            {template.leaderboard}
          </td>
        </tr>
      );
    });
  };

  const templateTableHeadings = () => {
    return DBObject.templateTableHeaders.map((header) => {
      return (
        <th
          key={uuid()}
          className="Patient-goal-table-heading-cell"
          style={header.id == 4 ? { justifyContent: "center" } : {}}
        >
          <span>{t(`views.goals.headings.${header.name}`)}</span>
        </th>
      );
    });
  };

  const templateTable = () => {
    if (selectedProgram.goalTemplateList.length == 0)
      return (
        <div style={{ marginBottom: "10px" }}>
          {t("views.goals.errors.no_templates_present_on_monitor_program")}
        </div>
      );
    return (
      <div className="goal-template-preview-table-wrapper">
        <div style={{ fontStyle: "italic" }}>{t("buttons.preview")}</div>
        <table className="patient-goal-table-wrapper">
          <thead>
            <tr className="patient-goal-table-heading-row">
              {templateTableHeadings()}
            </tr>
          </thead>
          <tbody>{buildTable()}</tbody>
        </table>
      </div>
    );
  };

  const renderModalContents = () => {
    return (
      <div className="goal-template-preview-container">
        <div style={{ marginTop: "10px" }}>
          {t("views.goals.errors.manual_reload_template_notice")}
        </div>
        <MonitorProgramDropdown
          selectedProgram={selectedProgram}
          setSelectedProgram={setSelectedProgram}
        />

        {selectedProgram ? templateTable() : null}
      </div>
    );
  };

  const selectProgram = () => {
    setMonitorProgramId(selectedProgram.id);
    closeModal();
  };

  return (
    <div className="patient-goal-activation-modal">
      <div className="patient-goal-modal-container ">
        <div className="patient-goal-preview-title">
          <span>{t("views.goals.form_titles.reload_goal_templates")}</span>
        </div>
        {renderModalContents()}
        <div className="patient-goal-footer-block">
          {selectedProgram ? (
            <GoalFormNavigationButton
              allow={true}
              handleClick={selectProgram}
              title={"load"}
            />
          ) : null}
          <GoalFormNavigationButton
            allow={true}
            handleClick={() => closeModal()}
            title="cancel"
          />
        </div>
      </div>
    </div>
  );
};
